import React from "react";
import {HeroImageSection} from "../components/common/HeroImageSection";
import {SideTitleSliderSection} from "../components/SideTitleSliderSection";

const JuniorPage: React.FC = () => {

    const kidsAreaSlides = [
        {
            image: '/images/kids_1.webp'
        },
        {
            image: '/images/kids_2.webp'
        },
        {
            image: '/images/kids_3.webp'
        }
    ]

    const gamingZoneSlides = [
        {
            image: '/images/gaming_1.webp'
        },
        {
            image: '/images/gaming_2.webp'
        },
        {
            image: '/images/gaming_3.webp'
        }
    ]

    const youthSportsSlides = [
        {
            image: '/images/youth_1.jpeg'
        },
        {
            image: '/images/youth_2.webp'
        },
        {
            image: '/images/youth_3.webp'
        }
    ]

    return (
        <div className="bg-dark-mode text-ivory">
            <HeroImageSection
                image="/images/gaming_1.webp"
                text="Junior Engagement"
                nextSectionId="kids-play-area-section"
            />
            <SideTitleSliderSection
                id="kids-play-area-section"
                title="DEDICATED KIDS PLAY AREA"
                slides={kidsAreaSlides}
            />
            <SideTitleSliderSection
                id="interactive-gaming-zone-section"
                title="INTERACTIVE GAMING ZONE"
                slides={gamingZoneSlides}
                isDark={true} isLeftAligned={false}
            />
            <SideTitleSliderSection
                id="youth-sports-section"
                title="YOUTH SPORTS"
                slides={youthSportsSlides}
            />
        </div>
    );
};

export default JuniorPage;